import { render, staticRenderFns } from "./collegeChartBar.vue?vue&type=template&id=811e75ec&"
import script from "./collegeChartBar.vue?vue&type=script&lang=js&"
export * from "./collegeChartBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports